import * as React from "react";
import { Button } from "@jhool-io/fe-components";
import { cn } from "../../../utils/helpers";
import ChevronDownIcon from "../../../components/Icons/ChevronDown";
import { APP_COLORS } from "../../../utils/constants";

interface FilterButtonProps
    extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    // Button text
    text: string;
    // Extra classnames for styling
    classNames?: string;
    // Icon stroke color
    stroke?: string;
    // This is in relation to the new app background flow, the idea is to deprecate this prop later
    mode?: "new" | "old";
}

const FilterButton = React.forwardRef<HTMLButtonElement, FilterButtonProps>(
    ({ text, classNames, stroke, mode = "old", ...props }, ref) => {
        return (
            <Button
                size="auto"
                variant="normal"
                className={cn(
                    "px-16 h-32 shadow-active gap-x-8 text-sm data-[state=open]:border-primary font-medium self-start md:self-center capitalize bg-white",
                    {
                        "bg-secondary100 shadow-[0px_1px_2px_0px_rgba(0,0,0,0.06),_0px_0px_0px_1px_rgba(87,106,129,0.16)]":
                            mode === "new",
                    },
                    classNames
                )}
                ref={ref}
                {...props}
            >
                {text}
                <ChevronDownIcon stroke={stroke || APP_COLORS.COLOR_BLACK} />
            </Button>
        );
    }
);

FilterButton.displayName = "FilterButton";
export default FilterButton;
